import React from 'react'
import VericredDocumentImport from './VericredDocumentImport'

export default function PlanServiceAreasImport() {
  return (
    <VericredDocumentImport importType="plan_service_areas" />
  )
}
